import type { RoleOverviewSourceData } from './RoleOverviewScreen.types'

export const ROLE_OVERVIEW_APPS_BY_ROLE: RoleOverviewSourceData = {
  project_manager: [
    {
      key: 'project_management',
      items: [
        { translationKey: 'define_r_and_d_projects_and_work_packages' },
        { translationKey: 'build_the_personnel_and_effort_plan' },
        { translationKey: 'resolve_overbookings_before_lock' }
      ]
    },
    {
      key: 'time_tracking',
      items: [
        { translationKey: 'log_research_hours' },
        { translationKey: 'review_and_approve_timesheets' },
        { translationKey: 'keep_effort_matching_the_plan' }
      ]
    },
    {
      key: 'tasks',
      items: [
        { translationKey: 'break_work_into_to_dos' },
        { translationKey: 'assign_owners_and_track_progress' },
        { translationKey: 'link_tasks_to_work_packages' }
      ]
    },
    {
      key: 'files',
      items: [
        { translationKey: 'upload_supporting_documents' },
        { translationKey: 'organize_by_year_and_project' },
        { translationKey: 'share_with_the_right_people' }
      ]
    }
  ],
  admin: [
    {
      key: 'compliance_center',
      items: [
        { translationKey: 'approve_application_steps' },
        { translationKey: 'handle_bsfz_inquiries' },
        { translationKey: 'drive_year_end_close_and_file_with_elster' }
      ]
    },
    {
      key: 'my_organization',
      items: [
        { translationKey: 'complete_base_data_and_tax_credentials' },
        { translationKey: 'keep_revenue_and_cost_figures_current' },
        { translationKey: 'confirm_the_financial_framework' }
      ]
    },
    {
      key: 'project_management',
      items: [
        { translationKey: 'define_r_and_d_projects_and_work_packages' },
        { translationKey: 'build_the_personnel_and_effort_plan' },
        { translationKey: 'resolve_overbookings_before_lock' }
      ]
    },
    {
      key: 'files',
      items: [
        { translationKey: 'upload_supporting_documents' },
        { translationKey: 'organize_by_year_and_project' },
        { translationKey: 'share_with_the_right_people' }
      ]
    }
  ],
  finance: [
    {
      key: 'compliance_center',
      items: [
        {
          translationKey: 'upload_payrolls_timesheets_and_employee_data',
          category: 'upload',
          priority: 2
        },
        { translationKey: 'categorize_uploaded_documents' }
      ]
    },
    {
      key: 'my_organization',
      items: [
        { translationKey: 'maintain_company_and_important_data' },
        { translationKey: 'keep_financial_figures_current' },
        { translationKey: 'manage_tax_and_elster_access' }
      ]
    },
    {
      key: 'accounting',
      items: [
        { translationKey: 'maintain_the_ledger' },
        { translationKey: 'track_invoices_and_costs' },
        { translationKey: 'reconcile_r_and_d_expenses' }
      ]
    },
    {
      key: 'files',
      items: [
        { translationKey: 'upload_supporting_documents' },
        { translationKey: 'organize_by_year_and_project' },
        { translationKey: 'share_with_the_right_people' }
      ]
    }
  ],
  hr: [
    {
      key: 'compliance_center',
      items: [
        {
          translationKey: 'upload_and_categorize_documents',
          category: 'upload',
          priority: 1
        },
        { translationKey: 'work_through_the_application_steps' },
        { translationKey: 'respond_to_bsfz_inquiries' }
      ]
    },
    {
      key: 'hr',
      items: [
        { translationKey: 'keep_employee_records' },
        { translationKey: 'track_contracts_and_absences' },
        { translationKey: 'provide_payroll_and_people_data' }
      ]
    },
    {
      key: 'files',
      items: [
        { translationKey: 'upload_supporting_documents' },
        { translationKey: 'organize_by_year_and_project' },
        { translationKey: 'share_with_the_right_people' }
      ]
    },
    {
      key: 'time_tracking',
      items: [
        { translationKey: 'log_research_hours' },
        { translationKey: 'review_and_approve_timesheets' },
        { translationKey: 'keep_effort_matching_the_plan' }
      ]
    }
  ]
}
